import { USA_AND_TERRITORIES } from '@airtm/utils/dist/constants';

export default (user: { country: string } & { [key: string]: any }) => {
  const { country } = user;

  return !['ARG', ...USA_AND_TERRITORIES].includes(country);
};
